import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { Layout } from '@/components/Layout';
import Home from '@/pages/Home';
import Blog from '@/pages/BlogPage';
import BlogPost from '@/pages/BlogPost';
import NotFound from '@/pages/not-found/Index';
import { ROUTE_PATHS } from '@/lib/index';

export default function App() {
  return (
    <MotionConfig reducedMotion="user">
      <Router>
        <Layout>
          <Routes>
            <Route path={ROUTE_PATHS.HOME} element={<Home />} />
            <Route path={ROUTE_PATHS.BLOG} element={<Blog />} />
            <Route path={ROUTE_PATHS.BLOG_POST} element={<BlogPost />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </Router>
    </MotionConfig>
  );
}
